import { useLang } from "@/i18n";

export default function Footer() {
  const { t } = useLang();
  const quickLinks = [
    { href: "#services", label: t("nav_services") },
    { href: "#investors", label: t("nav_investors") },
    { href: "#packages", label: t("nav_packages") },
    { href: "#faq", label: t("nav_faq") },
    { href: "#contact", label: t("nav_contact") },
  ];
  return (
    <footer data-testid="site-footer" className="border-t border-gold/15 bg-navy-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img src="/logo.png" alt="Barq Safe" className="h-14 w-14 object-contain rounded-xl bg-white/95 p-1" />
            <div>
              <div className="font-display font-extrabold text-lg">{t("brand")}</div>
              <div className="text-[11px] tracking-widest text-gold">{t("tagline")}</div>
            </div>
          </div>
          <p className="text-sm text-white/50 leading-relaxed">{t("footer_about")}</p>
        </div>
        <div>
          <h4 className="font-display font-bold mb-5 text-gold">{t("footer_links")}</h4>
          <ul className="space-y-3">
            {quickLinks.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-sm text-white/60 hover:text-gold transition-colors" data-testid={`footer-link-${l.href.slice(1)}`}>{l.label}</a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold mb-5 text-gold">{t("footer_platforms")}</h4>
          <ul className="space-y-3">
            {t("marquee_items").slice(0, 6).map((p) => (
              <li key={p} className="text-sm text-white/60">{p}</li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold mb-5 text-gold">{t("footer_contact")}</h4>
          <ul className="space-y-3 text-sm text-white/60">
            <li><a href="tel:+966579462600" dir="ltr" className="hover:text-gold transition-colors inline-block" data-testid="footer-phone">+966 57 946 2600</a></li>
            <li><a href="mailto:barq.safe.sa@gmail.com" className="hover:text-gold transition-colors" data-testid="footer-email">barq.safe.sa@gmail.com</a></li>
            <li className="text-sm text-white/60 leading-relaxed" data-testid="footer-address">{t("contact_location_value")}</li>
            <li className="pt-2"><a href="https://barqsafe-sa.com" className="text-gold font-semibold" data-testid="footer-domain">barqsafe-sa.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-white/40">
        © 2026 {t("footer_rights")}
      </div>
    </footer>
  );
}
